import React from 'react'
import {connect} from 'react-redux'
import MessageModal from "./MessageModal";
import {closeModals, modalWindowResize} from "./ModalsActions";
import {getModalsState} from "./ModalsReducer";
import {MODALS_TYPE_MESSAGE} from "./ModalsConstants";

const ModalsContainer = ({closeModals, modalWindowResize, modalsState}) => {

  const onWindowResize = () => {
    modalWindowResize({
      width: window.document.documentElement.clientWidth,
      height: window.document.documentElement.clientHeight
    });
  };

  const getOpenedModal = () => {
    if (modalsState.opened) {
      if (modalsState.modalType === MODALS_TYPE_MESSAGE) {
        window.addEventListener('resize', onWindowResize);
        return <MessageModal closeModal={closeModals} content={modalsState.content.messageModal} windowSize={modalsState.windowSize}/>;
      }
    }

    window.removeEventListener('resize', onWindowResize);
    return '';
  };

  return (
    getOpenedModal()
  );
};

ModalsContainer.propTypes = {};

const mapStateToProps = (state) => ({
  modalsState: getModalsState(state)
});

export default connect(
  mapStateToProps,
  {closeModals, modalWindowResize}
)(ModalsContainer);



// WEBPACK FOOTER //
// ./src/common/modals/ModalsContainer.js